import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m2.667 10 3.919-3.92a2 2 0 0 1 2.828 0l3.92 3.92"
	})
});
export default SvgChevronUp;
